import { ILoaiChungChiDanhSachMonSysRequest } from "../../model/request/chuong-trinh-dao-tao/IloaiChungChiDanhSachMonSysRequest";
import { apiClient } from "../apiClient";

export const LOAI_CHUNG_CHI_DANH_SACH_MON_ENDPOINT = "loai-chung-chi-danh-sach-mon";
export const loaiChungChiDanhSachMonApi = {
    Sys: (request: ILoaiChungChiDanhSachMonSysRequest) => apiClient.post(`${LOAI_CHUNG_CHI_DANH_SACH_MON_ENDPOINT}/sys`, request),
    SelectAll: () => apiClient.get(`${LOAI_CHUNG_CHI_DANH_SACH_MON_ENDPOINT}`),
}